/**
 * @Author: Li, Yu Jia
 * @Date: 2020-07-30 11:06:00
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-06-24 16:19:28
 */

import { imprintOptionType } from '../utils/constants';

export const IMPRINT_AREA_TITLE = 'Choose Your Imprint Option';
export const IMPRINT_OPTION_TYPE_TITLE = 'Choose Your Imprint Option';
export const IMPRINT_OPTION_LOGO_LAYOUT_TITLE = 'Choose Your Logo Layout Option';
export const IMPRINT_OPTION_LOGO_LAYOUT_NOTICE =
  'The images above are only examples. Depending on the product size and features, the actual size and location of the imprint may vary from that shown.';
export const IMPRINT_OPTION_TEXT_LAYOUT_TITLE = 'Choose Your Imprint Location Option';
export const PMS_COLOR_EXCEPTION_MESSAGE = 'Please enter a valid PMS color value or select a different color option.';
export const PMS_ENTRY_INVALID_MESSAGE = 'Your PMS color entry is invalid. Please try again.';
export const IMPRINT_OPTION_INVALID_MESSAGE = 'Please make a selection in the imprint options';
export const IMPRINT_COLOR_INVALID_MESSAGE = 'Please make a selection for the imprint color.';
export const IMPRINT_COLOR_GROUP_INVALID_MESSAGE = 'Please make a selection in each group of imprint locations.';
export const IMPRINT_LOCATION_OPTION_INVALID_MESSAGE = 'Please make a selection in the imprint location options.';
export const TOO_MANY_COLORS_CHOSEN_MESSAGE =
  'We apologize, but this item allows {maxColorCount} unique imprint {colorword}{colors} and you have selected {chosenCount} {colorword}s. Please update your selections and try again.';
export const TYPESETTING_LOCATION_LOGO = 'LOGO';
export const TYPESETTING_LOCATION_NONE = 'NONE';
export const TYPESETTING_LOCATION_NA = 'NA';
export const TYPESETTING_LOCATION_POPULAR = '(most popular)';
export const IMPRINT_OPTION_TEXT_COLOR_TITLE = 'Choose the color for your text';
export const imprintOptionTypeDescription = {
  TextOnly: 'Text Only',
  LogoOnly: 'Logo/Art Only',
  TextLogo: 'Logo/Art & Text',
  NoImprint: 'No Imprint',
};
export const imprintOptionTypeEntity = {
  TextOnly: {
    description: imprintOptionTypeDescription.TextOnly,
    icon: '/resources/assets/imprint/layout/TextOnly.svg',
    key: imprintOptionType.TextOnly,
    value: imprintOptionType.TextOnly,
    selected: false,
  },
  LogoOnly: {
    description: imprintOptionTypeDescription.LogoOnly,
    icon: '/resources/assets/imprint/layout/LogoOnly.svg',
    key: imprintOptionType.LogoOnly,
    value: imprintOptionType.LogoOnly,
    selected: false,
  },
  TextLogo: {
    description: imprintOptionTypeDescription.TextLogo,
    icon: '/resources/assets/imprint/layout/TextLogo.svg',
    key: imprintOptionType.TextLogo,
    value: imprintOptionType.TextLogo,
    selected: false,
  },
  NoImprint: {
    description: imprintOptionTypeDescription.NoImprint,
    icon: '/resources/assets/imprint/layout/NoImprint.svg',
    key: imprintOptionType.NoImprint,
    value: imprintOptionType.NoImprint,
    index: 3,
    selected: false,
  },
  NA: {
    key: imprintOptionType.NA,
    value: imprintOptionType.NA,
    selected: false,
  },
};

export const typeSettingLocationType = {
  Text: 0,
  Logo: 1,
};

export const MATCHTRIMCODE = ['MAT', 'MAC', 'TRM', 'MCT', 'ICL', 'SEO'];
